/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { boolean as codecBoolean, number as codecNumber } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { AbstractRole } from './AbstractRole';
import { GlobalPermMap } from './GlobalPermMap';
const RoleAsJSONWithPermsParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['perms', GlobalPermMap],
    ['own', codecBoolean],
    ['count', codecNumber],
]), AbstractRole);
export class RoleAsJSONWithPerms extends AbstractRole {
    static decode(input) {
        return RoleAsJSONWithPermsParser.decode(input).map(res => new RoleAsJSONWithPerms(res));
    }
    static unsafeDecode(input) {
        return RoleAsJSONWithPerms.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return RoleAsJSONWithPermsParser.encode(data);
    }
    static schema() {
        return RoleAsJSONWithPermsParser.schema();
    }
}
